import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { buildAgentSessionRequestConfig } from "./agentApiSession";

const PATH = "/api/agents/me/hubwayz-hotel-commission";

export async function fetchHubwayzHotelSaleCommission() {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.get(resolveApiUrl(PATH), {
    headers: cfg.headers,
    params: { sessionID: cfg.sid },
    withCredentials: cfg.withCredentials,
    timeout: cfg.timeout,
  });
  return data;
}

export async function saveHubwayzHotelSaleCommission(payload) {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.patch(
    resolveApiUrl(PATH),
    {
      hubwayz_hotel_commission_type: payload?.hubwayz_hotel_commission_type,
      hubwayz_hotel_commission_value: payload?.hubwayz_hotel_commission_value,
      sessionID: cfg.sid,
    },
    {
      headers: cfg.headers,
      withCredentials: cfg.withCredentials,
      timeout: cfg.timeout,
    }
  );
  return data;
}
